import * as tripSelectors from './selectors';
import * as types from './types';

function _getRoutedTrips(trip) {
    const originalTrip = {
        [trip.trip_id]: trip,
    };

    if (!trip.triplegs) {
        return originalTrip;
    }

    return trip.triplegs.filter((leg) => !!leg.trip_id)
        .reduce((trips, leg) => ({
            ...trips,
            [leg.trip_id]: leg,
        }), {});
}

function setTrip(tripId, data) {
    return {
        payload: {
            ..._getRoutedTrips(data),
            [tripId]: data,
        },
        type: types.SET_TRIPS,
    };
}

function setTripItinerary(tripId, data) {
    return {
        meta: {
            tripId,
        },
        payload: data,
        type: types.SET_TRIP_ITINERARY,
    };
}

function setTripInformation(tripId, data) {
    return {
        meta: {
            tripId,
        },
        payload: data,
        type: types.SET_TRIP_INFORMATION,
    };
}

function setTripNotFound(tripId) {
    return {
        meta: {
            tripId,
        },
        type: types.SET_TRIP_NOT_FOUND,
    };
}

function setTrips(data) {
    return {
        payload: {
            ...Object.values(data).reduce((trips, trip) => ({
                ..._getRoutedTrips(trip),
                ...trips,
            }), {}),
            /* it's not safe to make this the initial reductor value - there's a
             * chance that a routed trip has one of these guys as its sub-trip
             * and we don't want to overwrite anything */
            ...data,
        },
        type: types.SET_TRIPS,
    };
}

function updateTrip(tripId, data) {
    return {
        meta: {
            tripId,
        },
        payload: data,
        type: types.UPDATE_TRIP,
    };
}

function removeTrip(tripId) {
    return (dispatch, getState) => {
        tripSelectors.selectAllTripIds(getState())
            // remove any trips composed with the trip being removed
            .filter((id) => id.includes(tripId))
            .forEach((id) => {
                dispatch(_removeTrip(id));
            });
    };
}

function _removeTrip(tripId) {
    return {
        meta: {
            tripId,
        },
        type: types.REMOVE_TRIP,
    };
}

export {
    removeTrip,
    setTrip,
    setTripInformation,
    setTripItinerary,
    setTripNotFound,
    setTrips,
    updateTrip,
};
